import sidebar from '@/config/sidebars/service_titan'
import createVueApp from '@/common/create_app'

Styxie.Initializers.ServiceTitanTenants = {
  index: async(props) => {
    const { default: TenantsIndex } = await import('@/vue_widgets/service_titan/tenants/index.vue')
    createVueApp(TenantsIndex, { props, sidebar })
  }
}
